module.exports = __webpack_public_path__ + "static/media/server-maintenance.bf861778.svg";